import { profileColors } from '../../client/constants';
import {
  LoggedInSubAccount,
  LoggedInUser,
  ParentProfile,
  Profile,
  ProfileIconColor,
  ProfileIconImage,
  SubProfile,
} from '../../common/types';
import { isSubAccount } from '../../common/typeGuards';

export default function userAccountToStoredProfile(
  account: LoggedInUser | LoggedInSubAccount,
  cookie?: string
): Profile {
  const profileBase = {
    userId: account.userId,
    displayName: '',
    consent: account.consent,
    age: account.age ?? -1,
    initials:
      account.initials ?? account.displayName?.slice(0, 1).toUpperCase(),
  };

  if (isSubAccount(account)) {
    return {
      ...profileBase,
      displayName: account.displayName,
      parentId: account.parentId,
      icon: account.avatar
        ? ({
            type: 'image' as const,
            value: account.avatar,
          } satisfies ProfileIconImage)
        : ({
            type: 'color' as const,
            value: account.profileColor || profileColors[0],
          } satisfies ProfileIconColor),
      username: undefined,
      cookie,
    } satisfies SubProfile;
  } else if (cookie) {
    if (!account.username) {
      throw new Error('Parent profile is missing username');
    }
    return {
      ...profileBase,
      displayName: account.displayName ?? account.username,
      icon: {
        type: 'color' as const,
        value: account.profileColor || profileColors[0],
      } satisfies ProfileIconColor,
      parentId: null,
      cookie,
      username: account.username,
    } satisfies ParentProfile;
  } else {
    throw new Error('Parent profile is missing its cookie');
  }
}
